import request from '../../request';
import { useQuery } from '@tanstack/react-query';
import { TerminalSettingResponse } from '../../types/terminal-types';

export const useTerminalSettingQueries = (terminalSerialNumber: string) => {
  const enabled = Boolean(
    terminalSerialNumber && terminalSerialNumber !== 'unknown',
  );

  const fetchTerminalSetting = useQuery(
    ['terminalsSetting', terminalSerialNumber],
    async () =>
      request({
        method: 'get',
        url: '/api/v2/terminals/settings.json',
        params: { serial_number: terminalSerialNumber },
      }) as Promise<TerminalSettingResponse>,
    {
      enabled, // Only fetch when enabled is true
      // If the cached data is older than 3 minutes, the query will automatically fetch fresh data
      // the next time it is accessed.
      staleTime: 3 * 60 * 1000,
    },
  );

  return { fetchTerminalSetting, enabled }; // Return enabled flag
};
